export default "__VITE_ASSET__3a84bd83__"